//------------ IMPORTAÇÕES ------------//
import { useContext } from "react";
import "react-toastify/dist/ReactToastify.css";
import { formatterCurrency, formatterDate } from "../../../shared/utils";
import { TrafegoContext } from "../context/TrafegoContext";



//------------ EXPORTAÇÃO DA PÁGINA RELATÓRIO GRUPO ------------//
export default function TableReport() {



    //------------ CRIAÇÃO DE HOOKS ------------//
    const { report, setReport } = useContext(TrafegoContext); //  Estado que armazena a lista do Relatório


    //------------ VARIÁVEIS ------------//
    const valorInvestidoTotal = report.reduce((acc, item) => { 
        return acc + parseFloat(item.investido);
    }, 0);
    const valorReceitaTotal = report.reduce((acc, item) => {
        return acc + parseFloat(item.receita);
    }, 0);
    const valorLucroTotal = valorReceitaTotal - valorInvestidoTotal;


    //------------ RETORNO CONDICIONAL DA PÁGINA RELATÓRIO GRUPO ------------//
    return (
        <>

            {/* TABELA DE RELATÓRIOS */}
            <div className="bg-surface-2 rounded-xl overflow-hidden scrollbar scrollbar-thumb-zinc-700 scrollbar-track-zinc-900 overflow-x-scroll shadow border border-white/[0.08]">

                {/* TABELA */}
                <table className="w-full text-sm">

                    {/* CABEÇALHO DA TABELA */}
                    <thead className="bg-surface-3">
                        <tr>
                            <th className="p-3 text-left">Data</th>
                            <th className="p-3 text-left">Investido</th>
                            <th className="p-3 text-left">Receita</th>
                            <th className="p-3 text-left">Lucro</th>
                        </tr>
                    </thead>

                    {/* CORPO DA TABELA */}
                    <tbody>
                        {report.map((item, i) => {
                            const lucro = item.receita - item.investido;
                            const isNegativo = lucro < 0;
                            return (
                                <tr key={i} className="border-t border-white/[0.08]">
                                    <td className="p-3">{formatterDate(item.data)}</td>
                                    <td className="p-3">{formatterCurrency(item.investido)}</td>
                                    <td className="p-3">{formatterCurrency(item.receita)}</td>
                                    <td className={`p-3 font-bold ${isNegativo ? "text-red-500" : "text-green-400"}`}>
                                        {formatterCurrency(lucro)}
                                    </td>
                                </tr>
                            );
                        })}
                        {report.length === 0 && (
                            <tr><td colSpan="4" className="p-4 text-center text-ink-4">Nenhum dado encontrado</td></tr>
                        )}
                    </tbody>

                    {/* RODAPÉ DA TABELA */}
                    {report.length > 0 && (
                        <tfoot className="bg-surface-2">
                            <tr>
                                <th className="p-3 text-left">Totais</th>
                                <th className="p-3 text-left">{formatterCurrency(valorInvestidoTotal)}</th>
                                <th className="p-3 text-left">{formatterCurrency(valorReceitaTotal)}</th>
                                <th className={`p-3 text-left ${valorLucroTotal < 0 ? "text-red-500" : "text-green-400"}`}>{formatterCurrency(valorLucroTotal)}</th>
                            </tr>
                            <tr>
                                <th className="p-3 text-left">{`Médias (em ${report.length} dias)`}</th>
                                <th className="p-3 text-left">{formatterCurrency(valorInvestidoTotal / report.length)}</th>
                                <th className="p-3 text-left">{formatterCurrency(valorReceitaTotal / report.length)}</th>
                                <th className={`p-3 text-left ${valorLucroTotal / report.length < 0 ? "text-red-500" : "text-green-400"}`}>{formatterCurrency(valorLucroTotal / report.length)}</th>
                            </tr>
                        </tfoot>
                    )}

                </table>

            </div>
        </>
    );
}